// extracted by mini-css-extract-plugin
export default {"currencyEntry":"styles_currencyEntry__ZAT6o","rate":"styles_rate__Y3kwm"};